import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@e2n/ui';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type KalenderDeleteDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  kalender: TerminKalender;
  otherKalender: TerminKalender[];
  onConfirm: (idTargetTerminkalender?: string) => void;
  loading?: boolean;
};

export function KalenderDeleteDrawer({
  open,
  onOpenChange,
  kalender,
  otherKalender,
  onConfirm,
  loading,
}: KalenderDeleteDrawerProps) {
  const { t } = useTranslation();
  const [targetId, setTargetId] = useState<string | undefined>(undefined);

  return (
    <Drawer open={open} onOpenChange={onOpenChange} dismissible>
      <DrawerContent>
        <DrawerHeader className="text-left px-4">
          <DrawerTitle className="text-neutrals-900 text-xl py-2">
            {t('domain.termine.kalender.deleteDialog.title')}
          </DrawerTitle>
          <DrawerDescription className="text-neutrals-900">
            {t('domain.termine.kalender.deleteDialog.description', {
              name: kalender.name,
            })}
          </DrawerDescription>
        </DrawerHeader>

        <div className="flex flex-col gap-3 px-4 pt-2">
          <div>
            <p className="text-sm text-neutrals-900 pb-3">
              {t('domain.termine.kalender.deleteDialog.targetLabel')}
            </p>
            <Select onValueChange={setTargetId} value={targetId}>
              <SelectTrigger className="border-neutrals-300 w-full">
                <SelectValue
                  placeholder={t(
                    'domain.termine.kalender.deleteDialog.targetPlaceholder',
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {otherKalender.map((k) => (
                    <SelectItem key={k.id} value={k.id}>
                      {k.name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center gap-1 text-primary-orange-500 text-sm font-semibold">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
            <span>{t('domain.termine.kalender.deleteDialog.warning')}</span>
          </div>
        </div>

        <DrawerFooter className="flex flex-col gap-2 pt-4">
          <Button
            disabled={!targetId || loading}
            onClick={() => onConfirm(targetId)}>
            {t('domain.termine.form.fertig')}
          </Button>
          <DrawerClose asChild>
            <Button variant="outline">
              {t('domain.termine.deleteDialog.cancel')}
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
